/* eslint-disable no-extra-bind */
import { useEffect, useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { CONTENT_TYPE, CURRENCY, FOCUS_TYPE } from './constants';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { DEADOMAINS } from './dea-domains';
import Male from '../assets/images/Male.svg';
import Female from '../assets/images/Female.svg';
import NonBinary from '../assets/images/Non Binary.svg';
import InterSex from '../assets/images/Intersex.svg';
import Trans from '../assets/images/Transgender.svg';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from 'date-fns';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import axios from 'axios';
import { Api } from '../api';
import { PostApi } from '../api/api';

export const MaxCharlimitShort = 25;
export const MaxCharlimit = 100;
export const MaxCharlimitLongText = 1000;
export const getLocalStorageItem = (key) => localStorage.getItem(key);
export const setLocalStorageItem = (key, value) => localStorage.setItem(key, value);
export const removeLocalStorageItem = (key) => localStorage.removeItem(key);
export const cleanLocalStorage = () => localStorage.clear();
export const getJWTToken = () => 'Bearer ' + localStorage.getItem('token');
export const getDeviceToken = () => localStorage.getItem('deviceToken');
export const getUserType = (type) => {
  switch (type) {
    case 0:
      return 'Super Admin';
    // break;
    case 1:
      return 'Sub Admin';
    // break;
    case 2:
      return 'User';
    // break;
    case 3:
      return 'Company Admin';
    // break;
    case 4:
      return 'Company Sub Admin';
    // break;
    case 5:
      return 'Partner';

    case 6:
      return 'Expert';
    // break;

    default:
      return 'N/A';
    // break;
  }
};
// type === 0 ? "Super Admin" : type === 1 ? "Sub Admin" : "Company Admin";
export const getFocusType = (type) => FOCUS_TYPE.find((item) => item.value === type)?.name;
export const getMeditationType = (type) => (type === 1 ? 'Video' : 'Audio');

export const getAccountType = (type) =>
  type === 0
    ? 'In Trial'
    : type === 1
    ? 'Free User'
    : type === 2
    ? 'Subscribed'
    : type === 3
    ? 'Expired'
    : 'N/A';

export const getContentApprovalStatus = (type) => {
  return (
    <p
      className={`inline-flex m-0 rounded-full ${
        type === 1 ? 'bg-green-100' : type === 2 ? 'bg-red-100' : 'bg-orange-100'
      } px-4 py-[6px] text-sm leading-5 capitalize ${
        type === 1 ? 'text-green-400' : type === 2 ? 'text-red-400' : 'text-orange-400'
      }`}
    >
      {type === 1 ? 'Active' : type === 2 ? 'Rejected' : 'Draft'}
    </p>
  );
};

export const getSentToUser = (type) =>
  type === 1
    ? 'All'
    : type === 2
    ? 'In Trial'
    : type === 3
    ? 'Subscribed'
    : type === 4
    ? 'Custom User'
    : type === 5
    ? 'Expired'
    : type === 6
    ? 'Not Subscribed'
    : 'N/A';

export const getContentType = (type) => {
  let returnValue = '';
  CONTENT_TYPE?.forEach((item) => {
    if (item?.value === parseInt(type)) {
      returnValue = item.name;
    }
  });
  return returnValue ? returnValue : 'N/A';
};

export const getMultiBadge = (dataObject) => {
  const keys = Object.keys(dataObject);
  const badgeData = keys.map((key, index) => (
    <p
      key={index}
      className={`inline-flex ${index % 2 === 0 ? 'm-0' : 'mt-2'} rounded-full w-fit bg-${
        COLORS[index]
      }-100 ${`text-${COLORS[index]}-500`} px-3 text-md leading-5 capitalize font-extrabold tracking-normal`}
    >
      {`${key}: ${dataObject[key]}`}
    </p>
  ));

  const badgeColumns = [];
  for (let i = 0; i < badgeData.length; i += 2) {
    badgeColumns.push(
      <div key={i} className="flex flex-col mr-2">
        {badgeData[i]}
        {badgeData[i + 1] && badgeData[i + 1]}
      </div>
    );
  }

  return <div className="flex">{badgeColumns}</div>;
};

const COLORS = ['blue', 'cyan', 'red', 'green'];

export const errorToast = (msg, toastId = '') =>
  toast.error(msg, {
    duration: 2500,
    id: toastId
  });

export const successToast = (msg, duration = 2000) =>
  toast.success(msg, {
    duration
  });

export const informativeToast = (msg, duration = 3000) =>
  toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
      >
        <div className="flex-1 w-0 p-2">
          <div className="flex items-start">
            <div className="self-center">
              <InformationCircleIcon className="w-[24px] text-shoorah-secondary" />
            </div>
            <div className="ml-3 self-center">
              <p className="mt-1 text-gray-500">{msg}</p>
            </div>
          </div>
        </div>
      </div>
    ),
    {
      duration
    }
  );

export const useOutsideClick = (ref, callback) => {
  const handleClick = useCallback(
    (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    },
    [ref, callback]
  );

  useEffect(() => {
    const handleClickOutside = (e) => handleClick(e);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handleClick]);
};

export const capitalize = (value) => {
  let lowerCase = value?.toLowerCase();
  return lowerCase.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};

export const getFilterKey = (value) => {
  let key = value?.match(/([A-Z]?[^A-Z]*)/g).slice(0, -1);
  let returnKey = key?.toString()?.replaceAll(',', ' ').replaceAll('_', ' ');
  return capitalize(returnKey);
};

export const isSuperAdmin = () => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  return userData?.userType === 0;
};
export const isSubAdmin = () => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  return userData?.userType === 1;
};

export const isSuperAndSubAdmin = () => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  return userData?.userType === 0 || userData?.userType === 1;
};
export const isCopanySuperAdmin = () => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  return userData?.userType === 3;
};
export const isCopanySubAdmin = () => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  return userData?.userType === 4;
};
export const isCopanySuperOrSubAdmin = () => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  return userData?.userType === 3 || userData?.userType === 4;
};

export const isPartner = () => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  return userData?.userType === 5;
};

export const DeadDomainEmail = (email) => {
  const emailDomain = '@' + email.split('@')[1];
  return DEADOMAINS.includes(emailDomain);
};

export const ValueToPercentage = (value, max) => {
  return (value * 100) / max;
};

export const IsLastIndex = (j, length) => {
  return j === length - 1;
};

export const getGender = (type, flag) => {
  switch (type) {
    case 1:
      return flag ? Male : 'Male';
    case 2:
      return flag ? Female : 'Female';
    case 3:
      return flag ? NonBinary : 'Nonbinary';
    case 4:
      return flag ? InterSex : 'Intersex';
    case 5:
      return flag ? Trans : 'Transgender';
    default:
      return 'Not Preferred';
  }
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export const getFileType = (value) => {
  const fileExtension = value?.name?.split('.');
  const finalType = `${value?.type?.split('/')[0]}/${fileExtension[fileExtension?.length - 1]}`;
  return finalType;
};

/**
 * Converts a duration in seconds to a human-readable string.
 * Examples: 30 → "30 sec", 60 → "1 min", 90 → "1 min 30 sec",
 *           3600 → "1 hr", 3690 → "1 hr 1 min 30 sec"
 */
export const formatExerciseDuration = (seconds) => {
  if (!seconds && seconds !== 0) return '';
  const totalSeconds = parseInt(seconds, 10);
  if (isNaN(totalSeconds) || totalSeconds <= 0) return '';
  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  const parts = [];
  if (hrs > 0) parts.push(`${hrs} hr`);
  if (mins > 0) parts.push(`${mins} min`);
  if (secs > 0) parts.push(`${secs} sec`);
  return parts.join(' ');
};

export const jsonToCsv = (data) => {
  if (!data || data.length === 0) {
    return '';
  }
  const header = Object.keys(data[0]).join(',');
  const rows = data.map((item) => Object.values(item).join(','));
  return `${header}\n${rows.join('\n')}`;
};

export const convertToIndianDate = (date) => {
  if (!date || date === 'N/A') {
    return 'N/A';
  }
  const newDate = new Date(date);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZoneName: 'short'
  };
  const indianDate = newDate.toLocaleDateString('en-IN', options);
  return indianDate;
};

export const convertCodeToType = (code) => {
  let type;
  if (code === 0) {
    type = 'In Trial';
  } else if (code === 1) {
    type = 'Not Subscribed';
  } else if (code === 2) {
    type = 'Subscribed';
  } else if (code === 3) {
    type = 'Expired';
  }
  return type;
};

export const convertCodeToPlatform = (code) => {
  let type;
  if (code === 0) {
    type = 'Email';
  } else if (code === 1) {
    type = 'Apple';
  } else if (code === 2) {
    type = 'Gmail';
  } else if (code === 3) {
    type = 'Facebook';
  }
  return type;
};

export const convertCodeToUserType = (code) => {
  let type;
  if (code === 0) {
    type = 'Super Admin';
  } else if (code === 1) {
    type = 'Sub Admin';
  } else if (code === 2) {
    type = 'User';
  } else if (code === 3) {
    type = 'Company Admin';
  } else if (code === 4) {
    type = 'Company Sub Admin';
  } else if (code === 5) {
    type = 'Shoorah Partner';
  }
  return type;
};

export const convertCodeToStatus = (code) => {
  let type;
  if (code === 0) {
    type = 'Inactive';
  } else if (code === 1) {
    type = 'Active';
  }
  return type;
};

export const convertCodeToPurchasedDevice = (code) => {
  let type;
  if (code === 0) {
    type = 'Email';
  } else if (code === 1) {
    type = 'Gmail';
  } else if (code === 2) {
    type = 'Apple';
  } else if (code === 3) {
    type = 'Facebook';
  }
  return type;
};

export const addMonthOnDate = (date, len) => {
  let data = new Date(date);
  var newDate = new Date(data.setMonth(data.getMonth() + parseInt(len)));
  return newDate;
};
export const minusMonthOnDate = (date, len) => {
  let data = new Date(date);
  var newDate = new Date(data.setMonth(data.getMonth() - parseInt(len)));
  return newDate;
};
export const minusDayOnDate = (date, len) => {
  let data = new Date(date);
  var newDate = new Date(data.setDate(data.getDate() - parseInt(len)));
  return newDate;
};

export const monthDiff = (d1, d2) => {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};

export const currentDateWithFormat = (date) => {
  let yyyy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();
  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  return yyyy + '-' + mm + '-' + dd;
};

// export const getCurrentTime=()=>{
//   const dateTime = new Date();
//   dateTime.setHours(12);
//   dateTime.setMinutes(0);
// }
export const capitalizeFirstLetter = (string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};

// Utility function to capitalize first letter of each word (for names)
export const capitalizeWords = (str) => {
  if (!str) return str;
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const allFieldsNonEmpty = (data) => {
  if (!data) return false;

  const values = Object.values(data);

  const firstIsEmpty = isEmpty(values[0]);

  return values.every((value) => isEmpty(value) === firstIsEmpty);
};

const isEmpty = (value) => {
  return (
    (typeof value === 'string' && value.trim() === '') ||
    (Array.isArray(value) && value.length === 0) ||
    (value && typeof value === 'object' && Object.keys(value).length === 0) ||
    value === null ||
    value === undefined
  );
};

export const getCurrencyData = (data) => {
  const data1 = CURRENCY.filter((e) => e.value === data);
  if (data1.length > 0) {
    return data1[0].name;
  } else {
    return '';
  }
};

export const getCurrencyIcon = (data) => {
  const data1 = CURRENCY.filter((e) => e.value === data);
  if (data1.length > 0) {
    return data1[0].icon;
  } else {
    return '';
  }
};

export const dateFormat = (date) => {
  if (date) {
    let date1 = new Date(date);
    let year = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(date1);
    let month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date1);
    let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date1);
    return `${month} ${day},${year}`;
  } else {
    return date;
  }
};

export const downloadOWBMHReportToCSV = (data, fileName) => {
  let graphData = [];
  data.label.forEach((e, i) => {
    let obj = { date: e };
    data.series.forEach((a) => {
      obj[a.name] = `${Math.floor(a.data[i])} %`;
      obj[`${a.name}User`] = a.usersVoted[i];
    });
    graphData.push(obj);
  });
  const header = Object.keys(graphData[0]).join(',');
  const rows = graphData.map((item) => Object.values(item).join(','));
  const csvContent = `${header}\n${rows.join('\n')}`;
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName || 'data.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadOWBMHReportToPDF = (data, fileName) => {
  let graphData = [];
  data.label.forEach((e, i) => {
    let obj = { date: e };
    data.series.forEach((a) => {
      obj[a.name] = `${Math.floor(a.data[i])} %`;
      obj[`${a.name}User`] = a.usersVoted[i];
    });
    graphData.push(obj);
  });
  if (graphData.length === 0) {
    return;
  }
  // Create a new jsPDF instance
  const doc = new jsPDF('l');
  autoTable(doc, { html: '' });
  // Define the columns for the table
  const columns = Object.keys(graphData[0]);
  // Set the starting point for the table
  const chunkSize = 50; // Adjust this based on your data size
  // Function to add a chunk of data to the PDF
  const addDataChunkToPDF = (start, end) => {
    const chunk = graphData.slice(start, end);
    if (chunk.length > 0) {
      const data = chunk.map((row) => columns.map((e) => row[e])); // Modify this according to your data
      // Define table options with cell borders and text alignment
      const tableOptions = {
        startY: start === 0 ? 20 : 10, // Starting position from top
        head: [columns], // Table header
        body: data, // Table data
        theme: 'grid', // Apply grid theme for borders
        styles: {
          fontSize: 10,
          cellPadding: 2,
          halign: 'center', // Horizontal text alignment (centered)
          valign: 'middle' // Vertical text alignment (middle)
        }
      };
      // Generate the table in the PDF
      doc.autoTable(tableOptions);
      // Add a new page if needed
      if (end < graphData.length) {
        doc.addPage();
      }
    }
  };

  // Process data in chunks
  for (let i = 0; i < graphData.length; i += chunkSize) {
    const start = i;
    const end = Math.min(i + chunkSize, graphData.length);
    addDataChunkToPDF(start, end);
  }
  // Save the PDF with a filename
  doc.save(fileName);
};

export const convertLargeTextToPDF = (text, fileName) => {
  const doc = new jsPDF();
  const lineHeight = 12; // Adjust this based on your font size and style
  let cursorY = 10; // Initial Y position
  const margins = {
    top: 10,
    bottom: 10,
    left: 10,
    right: 10
  };
  const textLines = doc.splitTextToSize(
    text,
    doc.internal.pageSize.getWidth() - margins.left - margins.right
  );
  for (let i = 0; i < textLines.length; i++) {
    if (cursorY + lineHeight > 280) {
      doc.addPage(); // Create a new page if the content exceeds the page height
      cursorY = margins.top;
    }
    doc.text(margins.left, cursorY, textLines[i]);
    cursorY += lineHeight;
  }
  // Save or display the PDF
  doc.save(fileName);
};

export const downloadSingleRadialReportToCSV = (data, fileName, moodName) => {
  const header = data.label.join(',');
  const rows = [data.series.join(',')];
  const csvContent = `${moodName}\n${header}\n${rows.join('\n')}`;
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName || 'data.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadSingleRadialReportToPDF = (data, fileName, moodName) => {
  let graphData = [];
  let obj = {
    [data.label[0]]: data.series[0],
    [data.label[1]]: data.series[1],
    [data.label[2]]: data.series[2]
  };
  graphData.push(obj);
  // Create a new jsPDF instance
  const doc = new jsPDF('l');
  doc.setFontSize(20);
  doc.text(moodName + ' Graph Data', 20, 20);
  autoTable(doc, { html: '' });
  // Define the columns for the table
  const columns = Object.keys(graphData[0]);
  // Set the starting point for the table
  const chunkSize = 50; // Adjust this based on your data size
  // Function to add a chunk of data to the PDF
  const addDataChunkToPDF = (start, end) => {
    const chunk = graphData.slice(start, end);
    if (chunk.length > 0) {
      const data = chunk.map((row) => columns.map((e) => row[e])); // Modify this according to your data
      // Define table options with cell borders and text alignment
      const tableOptions = {
        startY: start === 0 ? 30 : 10, // Starting position from top
        head: [columns], // Table header
        body: data, // Table data
        theme: 'grid', // Apply grid theme for borders
        styles: {
          fontSize: 10,
          cellPadding: 2,
          halign: 'center', // Horizontal text alignment (centered)
          valign: 'middle' // Vertical text alignment (middle)
        }
      };
      // Generate the table in the PDF
      doc.autoTable(tableOptions);
      // Add a new page if needed
      if (end < graphData.length) {
        doc.addPage();
      }
    }
  };

  // Process data in chunks
  for (let i = 0; i < graphData.length; i += chunkSize) {
    const start = i;
    const end = Math.min(i + chunkSize, graphData.length);
    addDataChunkToPDF(start, end);
  }
  // Save the PDF with a filename
  doc.save(fileName);
};

export const surveyNavigate = (pathName, navigate) => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const isCompanyAdmin = Boolean(userData?.companyId);
  const url = !isCompanyAdmin ? pathName : '/' + userData?.slug + pathName;
  navigate(url);
};

export const getPathForSurvey = (pathName) => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const isCompanyAdmin = Boolean(userData?.companyId);
  return !isCompanyAdmin ? pathName : '/' + userData?.slug + pathName;
};

export const getPathForInstantSupport = (pathName) => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const isCompanyAdmin = Boolean(userData?.companyId);
  return !isCompanyAdmin ? pathName : '/' + userData?.slug + pathName;
};

export const getPathForTestFeature = (pathName) => {
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const isCompanyAdmin = Boolean(userData?.companyId);
  return !isCompanyAdmin ? pathName : '/' + userData?.slug + pathName;
};

export const generateWeeksForYear = (year) => {
  // Calculate whether the year has 53 weeks
  const isLeapYear =
    new Date(year, 0, 1).getDay() === 4 ||
    (new Date(year, 0, 1).getDay() === 3 && new Date(year, 0, 1).getFullYear() % 4 === 0);
  const totalWeeks = isLeapYear ? 53 : 52; // Leap year may have 53 weeks, adjust accordingly

  const weeks = [];
  for (let i = 1; i <= totalWeeks; i++) {
    weeks.push({ value: `${i}`, label: `Week ${i}` });
  }

  return weeks;
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const getKeyByValueFromArrayObj = (array, value) => {
  return array?.find((obj) => obj?.value === value)?.name;
};

export const tutorialsStatusColors = (status) => {
  switch (status) {
    case 0:
      return 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261]';
    case 1:
      return 'bg-[#DDF2BF] text-[#438038] border-[#438038]';
    case 2:
      return 'bg-[#FFFFED] text-[#8B8000] border-[#8B8000]';
    case 3:
      return 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261]';
    case 4:
      return 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261]';
    case 5:
      return 'bg-[#DDF2BF] text-[#438038] border-[#438038]';
    case 6:
      return 'bg-[#CBCBCB] text-[#808080] border-[#808080] ';
    default:
      return 'bg-[#F7F5F0] text-[#703115] border-[#703115]';
  }
};

export const contentApprovalStatusColors = (status) => {
  switch (status) {
    case 0:
      return 'bg-[#F7F5F0] text-[#703115] border-[#703115]';
    case 1:
      return 'bg-[#DDF2BF] text-[#438038] border-[#438038]';
    case 2:
      return 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261] ';
    default:
      return 'bg-[#F7F5F0] text-[#703115] border-[#703115]';
  }
};

export const surveyStatusColors = (status) => {
  switch (status) {
    case 0:
      return 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261] ';
    case 1:
      return 'bg-[#DDF2BF] text-[#438038] border-[#438038]';
    default:
      return 'bg-[#F7F5F0] text-[#703115] border-[#703115]';
  }
};
export const instantSupportStatusColors = (status) => {
  switch (status) {
    case 0:
      return 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261] ';
    case 1:
      return 'bg-[#DDF2BF] text-[#438038] border-[#438038]';
    default:
      return 'bg-[#F7F5F0] text-[#703115] border-[#703115]';
  }
};
export const getStatusBgColorPeapExpert = (status) => {
  switch (status) {
    case 'Pending review':
      return 'bg-[#f6e6cf]';
    case 'Send for approval':
      return 'bg-[#f6e6cf]';
    case 'Approved':
      return 'bg-green-500';
    case 'Declined':
      return 'bg-[#ffc6e4]';
    case 'Invite to interview':
      return 'bg-[#acecd0]';
    default:
      return 'bg-gray-500'; // Default color
  }
};
export const getWorkflowStatusBgColorPeapExpert = (status) => {
  switch (status) {
    case 1:
      return 'bg-[#C2EC97] text-[#2E6630]';
    case 2:
      return 'bg-[#ffbaba] text-[#662e2e]';
    default:
      return 'bg-[#ffbaba]'; // Default color
  }
};

export const getDaybyDate = (date) => {
  const days = ['Mon', 'Tue', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'];
  const dateObject = new Date(date).getDay();

  return days[dateObject];
};

export const encodeQueryData = (data) => {
  const ret = [];
  for (let d in data) ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
};

export const convertToNameCase = (str) => {
  return str
    ?.replace(/[_-]/g, ' ', 'g')
    ?.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};
export const convertKebabCase = (str) => {
  return str
    .split(' ')
    .map((item) => item.toLowerCase())
    .join('-');
};

export function getBase64(file, callback) {
  if (file) {
    var reader = new FileReader();

    reader.onload = function (e) {
      callback(e.target.result);
    }.bind(this);

    reader.readAsDataURL(file);
  }
}

export const formatDate = (date, dateFormat = 'MM/dd/yyyy') => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return ''; // Return an empty string if the date is invalid
  }

  try {
    return format(date, dateFormat); // Safely format the date
  } catch (error) {
    console.error('Error formatting date:', error); // Log unexpected errors
    return ''; // Return an empty string in case of unexpected errors
  }
};

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatAmount = (amount, short = false) => {
  if (amount == null) return '0';

  const num = parseFloat(amount.toString().replace(/,/g, ''));
  if (isNaN(num)) return '0';

  if (short) {
    const units = ['', 'K', 'M', 'B', 'T'];
    let unit = 0;
    let val = num;
    while (val >= 1000 && unit < units.length - 1) {
      val /= 1000;
      unit++;
    }
    return `${+val.toFixed(1)}${units[unit]}`;
  }

  return num.toLocaleString('en-GB');
};

export const formatAmountWithCurrency = (amount) => {
  if (amount == null || isNaN(amount)) return '£0';
  return `£${amount.toLocaleString('en-GB')}`;
};

export const convertWellpointsToPounds = (wellPoints) => {
  const ratePerWellPoint = 10; // 1 pound = 10 WellPoints
  return wellPoints / ratePerWellPoint;
};

export const convertToSubcurrency = (amountInCents, currency = 'gbp') => {
  // For USD, GBP, EUR, and other common currencies
  const conversionRates = {
    usd: 100, // cents to dollars
    gbp: 100, // pence to pounds
    eur: 100, // cents to euros
    jpy: 1 // yen is already in whole units
  };
  // Get the conversion rate for the given currency
  const conversionRate = conversionRates[currency.toLowerCase()] || 100; // Default to 100 for currencies like USD, GBP
  // Convert the amount by dividing by the conversion rate
  return amountInCents / conversionRate;
};

export const getPaymentStatus = (type) => {
  if (type === 1) return 'Paid';
  if (type === 2) return 'Unpaid';
  return 'N/A';
};

export const getPurchaseType = (type) => {
  if (type === 1) return 'Instant Purchase';
  if (type === 2) return 'Invoice';
  return 'N/A';
};

export const formatLabel = (label) => {
  if (typeof label !== 'string') {
    return ''; // Return an empty string or handle the case as needed
  }

  return label
    .replace(/_/g, ' ') // Replace underscores with spaces
    .toLowerCase() // Convert to lowercase
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};

export const getWeekdayLabels = () => {
  const currentDate = new Date();

  // Get the last 7 days including the current date
  const days = Array.from({ length: 7 }, (_, i) => {
    const date = new Date(currentDate);
    date.setDate(currentDate.getDate() - (6 - i)); // Adjust for the previous 6 days
    return date;
  });

  // Get weekday abbreviations (e.g., Mon, Tue, Wed, etc.)
  return days.map((date) => date.toLocaleDateString('en-US', { weekday: 'short' }));
};

export const roundToTwoDecimals = (amount) => {
  // Round the number to two decimal places
  const roundedAmount = Math.round(amount * 100) / 100;

  // Check if the number is an integer, if so return it as an integer
  return roundedAmount % 1 === 0 ? roundedAmount : parseFloat(roundedAmount.toFixed(2));
};

export const uploadImage = async (imageFile, uploadURL, fileName) => {
  try {
    const response = await axios.put(uploadURL, imageFile, {
      headers: {
        'Content-Type': imageFile.type
      }
    });
    if (response.status === 200) {
      return response;
    } else {
      throw new Error('Upload failed with status: ' + response);
    }
  } catch (error) {
    return error;
  }
};

export const uploadFileToAws = async (file, type, path) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    if (type) {
      formData.append('uploadType', type);
    }
    if (path) {
      formData.append('path', path);
    }

    const response = await PostApi('common/upload', formData, true);

    if (response.data?.meta?.code === 1) {
      return response.data?.data;
    } else {
      throw new Error('Upload failed with status: ' + response);
    }
  } catch (error) {
    return error;
  }
};

/**
 * True when a YYYY-MM-DD (or Date-parseable) value falls on a day after today.
 * Used to keep People Plan deadlines in the future.
 */
export const isFutureDate = (value) => {
  if (!value) return true; // let `required` own the empty case
  const selected = new Date(value);
  if (Number.isNaN(selected.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  selected.setHours(0, 0, 0, 0);
  return selected > today;
};

/** Tomorrow as YYYY-MM-DD — the `min` for a future-only date input. */
export const minFutureDateString = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString().split('T')[0];
};
